<template>
  <div class="filter_bar">
    <!--Bar-->
    <div class="flex flex-between flex-vertical-center">
      <!--Left Bar-->
      <div class="flex">
        <slot name="leftBar"></slot>
      </div>

      <!--Right Bar-->
      <div class="flex flex-end">
        <!--Filter Button-->
        <div class="flex flex-vertical-center">
          <p v-if="filterText" class="filter_text">{{ filterText }}</p>

          <button-outlined
            icon-left="filter"
            @click="openFilterSidebar = true"
            is-short
          >Filters
          </button-outlined>
        </div>

        <!--Refresh Button-->
        <template v-if="hasRefreshButton">
          <button-outlined
              @click="refresh"
              color="is-secondary"
              class="ml-100"
              is-short
          >Refresh
          </button-outlined>
        </template>

        <slot name="rightBar"></slot>
      </div>
    </div>

    <!--Sidebar-->
    <b-sidebar
      type="is-white"
      fullheight
      :overlay="false"
      right
      v-model="openFilterSidebar"
    >
      <div>
        <h4 class="filter_label">{{ label }} Filters:</h4>

        <slot></slot>

        <div class="flex flex-between filter_buttons">
          <button-link @click="reset">reset</button-link>
          <button-outlined @click="openFilterSidebar = false">Close</button-outlined>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "FilterBar",
  props: {
    label: {
      type: String,
      default: ""
    },
    filterText: String,
    reset: {
      type: Function,
      required: true
    },
    hasRefreshButton: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
      openFilterSidebar: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.filter_bar {
  width: 100%;
  padding: 10px 0;
}

.filter_text {
  margin-right: 12px;
  font-size: 0.8rem;
  font-style: italic;
}

.filter_label {
  padding: 1rem;
  color: $text-light;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.filter_buttons {
  padding: 0 18px 18px;
}
</style>
